.ColorBlock {
  width: 2em;
  height: 1em;
}
